import { z } from "zod";
import { success } from "@secretaa/http-contract";
import { Usage } from "./ai-model-control.ts";
/** Owner service supplies historical correlation from its journal. Never a user/model tool. */
export const Command=z.object({providerKey:z.string().regex(/^[a-z][a-z0-9_.-]{0,95}$/),providerRequestId:z.string().regex(/^[A-Za-z0-9][A-Za-z0-9_.:-]{0,127}$/)}).strict();
export type Command=z.infer<typeof Command>;
export const Result=Command.extend({usage:Usage.nullable()}).strict().refine(r=>r.usage===null||r.usage.providerRequestId===r.providerRequestId,"USAGE_CORRELATION_MISMATCH");
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
export const PATH="/internal/v1/ai/usage/read";
export const CONTRACT_VERSION="1.1.0";
